import { type FC, type ReactNode } from 'react';

import { fullPage } from './styles';

interface IProps {
  children: ReactNode;
}

export const FullPageWrapper: FC<IProps> = ({ children }) => <div className={fullPage}>{children}</div>;
